export const FETCH_STORES = 'Stores/FETCH_STORES'
export const FETCH_STORES_SUCCESS = 'Stores/FETCH_STORES_SUCCESS'
export const FETCH_STORES_ERROR = 'Stores/FETCH_STORES_ERROR'
export const FETCH_STORES_DONE = 'Stores/FETCH_STORES_DONE'
